






































































































































































































import { Component, Vue } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { PASSWORD_POLICY_REGEX } from "@/helpers/passwordPolicy";
import i18n from "@/services/i18n";

@Component({})
export default class Users extends Vue {
  dialog = false;
  dialogPwd = false;

  showPwdNew = false;

  isNew = true;

  editedIndex = -1;

  defaultItem = {
    id: "",
    userName: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    emailAddress: "",
    active: true,
    type: 0,
    typeS: "0",
    password: "",
    password2: "",
  };

  show1 = false;

  editedItem = Object.assign({}, this.defaultItem);

  /**
   * Policy help line is a sibling `v-show` block (not `v-text-field` hint): Vuetify 1 can leave hint text visible
   * when switching from rule text to an empty `hint` — same for validation errors, which also use that string.
   */
  get isFirstPasswordPolicySatisfied() {
    const p = this.editedItem.password;
    return Boolean(p && PASSWORD_POLICY_REGEX.test(p));
  }

  /** Vuetify invokes rules without binding component `this` — use i18n singleton and getter so `this` is the vm. */
  get rules() {
    const pwdRuleMsg = String(i18n.t("CHANGE_PASSWORD_RULE"));
    const mismatchMsg = String(i18n.t("CHANGE_PASSWORD_MISMATCH"));
    return {
      required: (value: any) => !!value || "Szükséges.",
      min: (v: string) => v.length >= 3 || "Legalább 3 Betű",
      matching: (v: string) => PASSWORD_POLICY_REGEX.test(v) || pwdRuleMsg,
      passwordStrength: (v: string) => PASSWORD_POLICY_REGEX.test(v) || pwdRuleMsg,
      /** First field: if confirm is empty, do not show mismatch (required handles empty). */
      passwordMatchFirst: (v: string) => {
        const p2 = this.editedItem.password2;
        if (!p2) return true;
        if (!v) return true;
        return v === p2 || mismatchMsg;
      },
      /** Second field: must equal first password. */
      passwordMatchSecond: (v: string) => v === this.editedItem.password || mismatchMsg
    };
  }

  onPasswordInputNew() {
    this.revalidatePairedPasswordFields("pwdNew1", "pwdNew2");
  }

  onPasswordInputDialog() {
    this.revalidatePairedPasswordFields("pwdDialog1", "pwdDialog2");
  }

  revalidatePairedPasswordFields(
    a: "pwdNew1" | "pwdDialog1",
    b: "pwdNew2" | "pwdDialog2"
  ) {
    this.$nextTick(() => {
      const t1 = this.$refs[a] as { validate?: (force: boolean) => void } | undefined;
      const t2 = this.$refs[b] as { validate?: (force: boolean) => void } | undefined;
      if (t1 && t1.validate) t1.validate(true);
      if (t2 && t2.validate) t2.validate(true);
    });
  }

  dollySearchTerm = "";
  localDollies = [];

  rowsPerPageItems = [5, 10, 25, 50, { text: "All", value: -1 }];

  pagination = {
    sortBy: "UserName",
    descending: false,
    page: 1,
    rowsPerPage: this.$cookies.isKey("users-rowsPerPage") ?
                        parseInt(this.$cookies.get("users-rowsPerPage"), 10) : 10
  };
  totalUserItem = 2;

  @State("users") usersState: any;
  @State("auth") authState: any;
  @Action("getUsers") getUsers: any;
  @Action("saveUser") saveUser: any;
  @Action("deleteUser") deleteUser: any;
  @Action("saveNewPassword") saveNewPassword: any;

  @State("dollies") dollyState: any;
  @Action("getDollies") getDollies: any;

  formTitle() {
    return this.editedIndex === -1
      ? this.$t("ADMIN_USERS_NEW")
      : this.$t("ADMIN_USERS_EDIT");
  }

  created() {
    // --
  }

  getHeaders() { return [
      { text: " ", value: "", sortable: false, width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_PASSWORD"), value: "password", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_USER_NAME"), value: "userName", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_NAME"), value: "", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_ACTIVE_INACTIVE"), value: "active", width: "1%" },
      { text: this.$t("ADMIN_USERS_TABLE_ROLE"), value: "type", width: "1%" },
    ];
  }

  // lapozáskor hívódik meg, ill. ha item/oldalszámot választunk
  updatePagination(pagination) {

    this.$cookies.set("users-rowsPerPage", pagination.rowsPerPage);

    const page = {
      sortBy: pagination.sortBy,
      descending: pagination.descending,
      page: pagination.page,
      rowsPerPage: pagination.rowsPerPage
    };
    this.getUsers(page);
  }
  reload() {
    this.updatePagination(this.pagination);
  }

  editItem(item) {
    this.isNew = false;
    this.editedIndex = this.usersState.users.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.editedItem.typeS = this.editedItem.type.toString();

    this.dialog = true;
  }

  deleteItem(item) {
    // Prevent self-deletion
    if (this.authState.currentUser && this.authState.currentUser.id === item.id) {
      alert(this.$t("USER_DELETE_SELF_ERROR") as string);
      return;
    }

    const index = this.usersState.users.indexOf(item);

    if (confirm(this.$t("USER_DELETE_CONFIRM") as string)) {
      this.deleteUser({ id: item.id, index });
    }
  }

  close() {
    this.dialog = false;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.editedIndex = -1;
    this.isNew = true;
  }

  save() {

    if (this.editedItem.id === "" && this.editedItem.userName === "") {
      this.usersState.userSnacktext = "A felhasználónév kötelező.";
      this.usersState.userSnackbar = true;
      // validation failed.
      return;
    }

    if (  this.editedItem.lastName === "" || this.editedItem.firstName === "") {
      this.usersState.userSnacktext = "A vezeték és utónév kötelező";
      this.usersState.userSnackbar = true;
      // we need to have last name
      return;
    }

    if (this.isNew) {
      if (
        !this.editedItem.password ||
        this.editedItem.password !== this.editedItem.password2
      ) {
        this.usersState.userSnacktext =
          "Új felhasználóhoz meg kell adni az ideiglenes jelszót kétszer, egyezően.";
        this.usersState.userSnackbar = true;
        return;
      }
      if (!PASSWORD_POLICY_REGEX.test(this.editedItem.password)) {
        this.usersState.userSnacktext = this.$t("CHANGE_PASSWORD_RULE") as string;
        this.usersState.userSnackbar = true;
        return;
      }
    }

    this.editedItem.type = parseInt(this.editedItem.typeS, 10);
    this.saveUser({
      data: JSON.stringify(this.editedItem),
      index: this.editedIndex
    }).then(res => {
      this.close();
    }).catch(err => {
      // ---
    });
  }

  sendPasswordReset(item ) {

    console.log(item);

    this.editedItem = item;
    this.editedItem.password = "";
    this.editedItem.password2 = "";

    this.dialogPwd = true;
  }

  closePwd() {
    this.dialogPwd = false;
  }

  savePwd() {

    if (this.editedItem.id === "") {
      this.usersState.userSnacktext = "Nincs felhasználó kiválasztva";
      this.usersState.userSnackbar = true;
      // validation failed.
      return;
    }

    if (this.editedItem.password !== this.editedItem.password2 || this.editedItem.userName === "" ) {
      this.usersState.userSnacktext = "A jelszavakat meg kell adni és egyezniük kell";
      this.usersState.userSnackbar = true;
      // validation failed.
      return;
    }

    this.saveNewPassword({
      userId: this.editedItem.id,
      password: this.editedItem.password
    }).then(res => {
      this.closePwd();
    }).catch(err => {
      // ---
    });
  }
}
